import Vue from "vue";
import Vuex from "vuex";

import URL_CONST from "@/kuaa/kuaa-url-const";

const API_HOST = process.env.VUE_APP_URL;
// const API_HOST = "//61.74.145.248:8090";

import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

const state = {
  host: API_HOST,
  userNo: "",
  userName: "",
  levelCode: "",
  accessToken: null,
  refreshToken: null,
  isAuth: true,
  loginInfo: {}
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',  //
  namespaced: true,
  state,
  mutations,
  getters,
  actions
});
